import React from 'react'
import styles from '../../styles/Products.module.scss'
import { Link } from 'react-router-dom'
import { assetUrl } from '../../utils/imageUrl'
import { getFirstWholesaleTier, hasDiscount, hasWholesaleTiers } from '../../utils/productPrice'
import ProductImage from '../common/ProductImage'
import ProductBadges from './ProductBadges'
import { getProductUrl } from '../../utils/urls'

const Products = ({ title, style = {}, products = [], amount, fullBleed = false }) => {
  const list = products.filter((_, i) => i < amount);

  return (
    <section
      className={`${styles.products}${fullBleed ? ' productsFullBleed' : ''}`}
      style={style}
    >
      {title && <h2>{title}</h2>}

      <div className={styles.list}>
        {list.map((product) => {
          const { id, images, title, price, oldPrice, article } = product;
          const wholesaleTier = getFirstWholesaleTier(product);
          return (
          <Link to={getProductUrl(product)} key={id} className={styles.product}>
            <ProductBadges product={product} className={styles.cardBadges} giftPreview />
            <div className={styles.image}>
              <ProductImage src={assetUrl(images[0])} alt={title} />
            </div>

            <div className={styles.wrapper}>
              <h3 className={styles.title}>{title}</h3>
              {article && (
                <div className={styles.article}>Артикул: {article}</div>
              )}
              <div className={styles.info}>
                <div className={styles.prices}>
                  <div className={styles.priceRow}>
                    <div className={styles.price}>{price}₴</div>
                    {hasDiscount(price, oldPrice) && (
                      <div className={styles.oldPrice}>{oldPrice}₴</div>
                    )}
                  </div>
                  {hasWholesaleTiers(product) && wholesaleTier && (
                    <div className={styles.wholesale}>
                      від {wholesaleTier.minQty} шт. — {wholesaleTier.price}₴
                    </div>
                  )}
                </div>
              </div>
            </div>
          </Link>
          );
        })}
      </div>
    </section>
  );
};

export default Products;
